import { PageNotFoundComponent } from './page-not-found.component';

export { PageNotFoundComponent };
